const skillGroups = [
  {
    title: "Technical Leadership",
    skills: [
      "TypeScript",
      "JavaScript",
      "React",
      "React Native",
      "Node.js",
      "C++",
      "C",
      "Objective-C",
      "Java",
      "Ruby",
      "Android",
      "iOS",
      "Rails",
      "AWS",
      "Azure",
      "Heroku",
      "TDD",
      "Agile / XP",
      "Systems Architecture",
      "Pair Programming",
    ],
  },
  {
    title: "Product Leadership",
    skills: [
      "Lean Startup",
      "Customer Development",
      "Product Strategy",
      "Roadmap Development",
      "User Research",
      "Pricing Research",
      "A/B Testing",
      "UX Design",
      "Mobile Applications",
    ],
  },
  {
    title: "Business Leadership",
    skills: [
      "Business Strategy",
      "Fundraising & Pitching",
      "Board Management",
      "Budgeting & Forecasting",
      "KPI Definition & Tracking",
      "Digital Marketing",
      "Mobile App Install Campaigns",
      "Culture & Team Building",
      "Cross-Functional Leadership",
    ],
  },
];

export function Skills() {
  return (
    <section id="skills" className="section">
      <div className="section-inner">
        <h2 className="section-title">Skills</h2>
        {skillGroups.map((group) => (
          <div className="skills-group" key={group.title}>
            <h3 className="skills-group-title">{group.title}</h3>
            <div className="skills-tags">
              {group.skills.map((skill) => (
                <span className="skill-tag" key={skill}>
                  {skill}
                </span>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
